export default (context:any, payload:any) => {
    const setAttribute = payload.oneLni.storeUtils.setAttribute;
    setAttribute(context, payload.sourceId, 'overall', context.rootState[`${payload.sourceId}_overall`].value);
    setAttribute(context, payload.sourceId, 'lowerExtremity', context.rootState[`${payload.sourceId}_lower-extremity`].value);
    setAttribute(context, payload.sourceId, 'handWrist', context.rootState[`${payload.sourceId}_hand-wrist`].value);
    setAttribute(context, payload.sourceId, 'shoulder', context.rootState[`${payload.sourceId}_shoulder`].value);
    setAttribute(context, payload.sourceId, 'lowerBack', context.rootState[`${payload.sourceId}_lower-back`].value);
};